// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"339":"398946ff","429":"723ad417","494":"21c98cc9"}[chunkId] + ".chunk.css";
};